
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M13.163 21.89l-.106-3.043 2.657-1.63a2.003 2.003 0 003.134-1.711 2.027 2.027 0 00-1.943-1.944 1.991 1.991 0 00-2.035 2.32l-1.875 1.16-.136-3.834 2.615-1.6a2.357 2.357 0 102.82-3.778 2.357 2.357 0 00-3.698 2.456l-1.8 1.117-.106-3.06a2.144 2.144 0 10-1.544 0l-.194 6.34-1.96-1.248a2.331 2.331 0 00-.176-1.59c-.391-.816-1.181-1.394-2.082-1.45a2.483 2.483 0 101.43 4.384l2.731 1.728-.164 5.37c-4.89-.623-8.687-4.814-8.687-9.874.003-5.49 4.468-9.956 9.956-9.956 5.489 0 9.953 4.465 9.953 9.955 0 5.096-3.848 9.31-8.79 9.888M23 12.003C23 5.934 18.065 1 12 1S1 5.934 1 12.003c0 5.732 4.406 10.455 10.01 10.957h.026c.092.008.184.015.277.02l.053.004c.084.005.168.008.254.011h.068c.104 0 .208.005.313.005.105 0 .199 0 .298-.004h.042c.087-.003.174-.006.26-.011h.018c.195-.01.39-.027.582-.048C18.703 22.34 23 17.664 23 12.003","fill":"#333E48"}}),_c('path',{attrs:{"d":"M11.919 5.047a1.3 1.3 0 100 2.6 1.3 1.3 0 000-2.6M16.818 14.413A1.18 1.18 0 1018 15.592v-.002a1.181 1.181 0 00-1.182-1.177M17.545 10.99a1.389 1.389 0 10-1.856-.64 1.39 1.39 0 001.856.64M6.58 11.376a1.497 1.497 0 100 2.994 1.497 1.497 0 000-2.994","fill":"#009BDE"}})])])
          )
        }
      }
    